/**
 * PrivacyPage.jsx — iter881
 *
 * Dedicated /privacy URL for Google OAuth consent screen.
 * Renders only the Privacy-relevant sections of LegalPage:
 *   • GDPR Privacy Policy
 *   • AI Methodology + Subprocessors + Retention
 *   • Disclaimer + Data Controller
 */
import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function PrivacyPage() {
  return <LegalPage variant="privacy-only" pathOverride="/privacy" />;
}
